<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="createEntity"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="entityId"
  />
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import LegalInfoPageDataService from '@/services/api/LegalInfoPageDataService'
  import RouteName from '@/models/enums/RouteName'

  export default {
    components: { EntityEditForm },
    data () {
      return {
        title: 'Новая страница',
        dataService: LegalInfoPageDataService,
        fields: LegalInfoPageDataService.getCrudFields(),
        listRouteName: RouteName.LegalInfoPages,
      }
    },
    computed: {
      entityId () {
        return this.$route.params.id
      },
      createEntity () {
        return !this.entityId
      },
    },
    created () {
      if (this.entityId) {
        this.title = 'Редактирование страницы'
      }
    },
  }
</script>
